import * as React from 'react';
import { forwardRef } from 'react';

export type DMVideoProps = React.VideoHTMLAttributes<HTMLVideoElement>;

export const DMVideo = forwardRef<HTMLVideoElement, DMVideoProps>(
  ({ className = '', children, ...props }, ref) => {
    return (
      <video ref={ref} className={className} {...props}>
        {children}
      </video>
    );
  },
);
DMVideo.displayName = 'DMVideo';
